import { all, fork, put, select, takeLatest } from 'redux-saga/effects';
import { getCurrentLocation } from '../iwRouter/HistoryProvider';
import { CHANGE_ROUTER, UPDATE_URL } from '../iwRouter/IwRouter.actions';
import {
    addQueryParameterInLocation,
    removeQueryParameterInLocation
} from '../iwRouter/LocationHelper';
import {
    CLOSE_MODAL,
    CLOSE_MODAL_READY,
    OPEN_MODAL,
    OPEN_MODAL_READY
} from './Modals.actions';
import { getOpenModalActionName, isModalOpenInURL } from './ModalsHelper';

export const iwModalsWorkers = [
    fork(openUpdateURLWorker),
    fork(closeUpdateURLWorker),
    fork(closeModalOnUpdateURLWorker)
];

function* openUpdateURLWorker() {
    yield takeLatest(OPEN_MODAL, function* (action) {
        const currentLocation = getCurrentLocation();
        const newLocation = addQueryParameterInLocation(
            currentLocation,
            'modal',
            action.id
        );

        yield all([
            put({ type: OPEN_MODAL_READY, id: action.id }),
            put({
                type: UPDATE_URL,
                pathname: newLocation.pathname,
                search: newLocation.search,
                options: { keepScrollPosition: true }
            })
        ]);

        yield put({ type: getOpenModalActionName(action) });
    });
}

function* closeUpdateURLWorker() {
    yield takeLatest(CLOSE_MODAL, function* () {
        const currentLocation = getCurrentLocation();
        const newLocation = removeQueryParameterInLocation(
            currentLocation,
            'modal'
        );

        yield all([
            put({ type: CLOSE_MODAL_READY }),
            put({
                type: UPDATE_URL,
                pathname: newLocation.pathname,
                search: newLocation.search,
                options: { keepScrollPosition: true }
            })
        ]);
    });
}

function* closeModalOnUpdateURLWorker() {
    yield takeLatest(CHANGE_ROUTER, function* (action) {
        const { openModalId } = yield select(({ modals }) => modals);

        if (openModalId && !isModalOpenInURL(action.location, openModalId)) {
            yield put({ type: CLOSE_MODAL_READY });
        }
    });
}
